<app-submit-post-payment *ngIf="postPayment" [campaignDraft]="campaignDraft"
                         (isSubmitting)="isSubmitting.next($event)"
                         (submitResult)="campaignDraft.sendUpdate($event)">
</app-submit-post-payment>
<app-submit-payment *ngIf="!postPayment" [campaignDraft]="campaignDraft"
                    (isSubmitting)="isSubmitting.next($event)"
                    (submitResult)="campaignDraft.sendUpdate($event)">
</app-submit-payment>
